import Image from 'next/image';
import { Stack, Box, Theme } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import Link from 'next/link';
const LogoHeader = (props: {
  sx?: SxProps<Theme>;
}) => {
  return <Stack sx={{
    pt: 'var(--spacing_xxxl)',
    pb: 'var(--spacing_xl)',
    alignItems: 'center',
    background: 'linear-gradient(180deg, rgba(229, 242, 255, 1) 0%, rgba(255, 255, 255, 1) 100%)',
    ...props.sx
  }} data-sentry-element="Stack" data-sentry-component="LogoHeader" data-sentry-source-file="LogoHeader.tsx">
      <Box sx={{
      height: 58
    }} component={Link} href='/' data-sentry-element="Box" data-sentry-source-file="LogoHeader.tsx">
        <Image src='/images/zeema-logo.svg' alt='لوگوی زیما' width={158} height={58} data-sentry-element="Image" data-sentry-source-file="LogoHeader.tsx" />
      </Box>
    </Stack>;
};
export default LogoHeader;